<template>
  <div class="item-err-tip" v-if="txt">
    <!-- <img class="item-err-tip-img" src="../../../assets/image/common/icongth2.png"></img> -->
    <!--文本为：提示-->
    <div class="item-err-tip-txt">Hướng dẫn：{{txt || ''}}</div>
  </div>
</template>

<script>
export default {
  props: ["txt"]
};
</script>

<style lang="less" scoped>
.item-err-tip{
  background: #fff6f2;
  border-radius: 5px;
  padding: 6px 12px 6px 38px;
  position: relative;
  margin-bottom: 15px;
}
.item-err-tip-img{
  width: 15px;
  height: 15px;
  position: absolute;
  top: 6px;
  left: 12px;
  filter: opacity(0.7);

}
.item-err-tip-txt{
  color: #FF5F20;
  font-size: 12px;
  line-height: 15px;
  overflow: hidden;
  letter-spacing: 1px;
  text-overflow: -o-ellipsis-lastline;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
</style>
